module.exports = __webpack_public_path__ + "img/common-file-add.f2887a3d.svg";